import { useContext } from "react";
import PortalContext from "../../Pages/PortalContext";
import { Trash2, CirclePlus } from "lucide-react";

export default function SkuRow(props) {
  const { portal } = useContext(PortalContext);

  const index = props.itemState?.index ?? 0;
  const quantity = props.itemState?.quantity ?? 1;
  const reason = props.itemState?.reason ?? "";
  const action = props.itemState?.action ?? "";
  const productName = props.itemState?.name ?? "";

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "productName") {
      props.setItem(index, { name: value });
      return;
    }

    if (name === "quantity") {
      props.setItem(index, { quantity: Number(value) || 0 });
      return;
    }

    // reason / action
    props.setItem(index, { [name]: value });
  };

  const selectStyle = {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    backgroundColor: "white",
    color: "black",
    paddingRight: "1rem",
    backgroundImage:
      "url(\"data:image/svg+xml;utf8,<svg fill='%23333' height='12' viewBox='0 0 20 20' width='12' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 0.75rem center",
    backgroundSize: "1rem",
    border: "1px solid #ccc",
    borderRadius: "5px",
  };

  // sometimes the list comes as an object, sometimes as an array
  const normalizeList = (value) => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") return Object.values(value);
    return [];
  };

  const actionsList = normalizeList(portal?.data?.settings?.actionsList);

  return (
    <div className="py-2">
      <div className="row g-2 item-border-mobile">
        <div className="col-12 col-sm-4">
          <input
            className="w-100"
            type="text"
            placeholder="Product Name"
            name="productName"
            value={productName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-12 col-sm-1 d-none d-sm-block">
          <select
            id="quantity"
            name="quantity"
            className="w-100 text-align-center"
            value={String(quantity || 1)}
            onChange={handleChange}
            required
            style={selectStyle}
          >
            <option value={"1"}>1</option>
            <option value={"2"}>2</option>
            <option value={"3"}>3</option>
            <option value={"4"}>4</option>
            <option value={"5"}>5</option>
            <option value={"6"}>6</option>
            <option value={"7"}>7</option>
            <option value={"8"}>8</option>
            <option value={"9"}>9</option>
            <option value={"10"}>10</option>
          </select>
        </div>

        <div className="col-12 col-sm-1 d-block d-sm-none">
          <select
            id="quantity"
            name="quantity"
            className="w-100 text-align-center"
            value={String(quantity || 1)}
            onChange={handleChange}
            required
            style={selectStyle}
          >
            <option value={"1"}>Quantity: 1</option>
            <option value={"2"}>Quantity: 2</option>
            <option value={"3"}>Quantity: 3</option>
            <option value={"4"}>Quantity: 4</option>
            <option value={"5"}>Quantity: 5</option>
            <option value={"6"}>Quantity: 6</option>
            <option value={"7"}>Quantity: 7</option>
            <option value={"8"}>Quantity: 8</option>
            <option value={"9"}>Quantity: 9</option>
            <option value={"10"}>Quantity: 10</option>
          </select>
        </div>

        <div className="col-12 col-sm-3 dropdown-border">
          <select
            id="reason"
            name="reason"
            className="w-100"
            value={reason}
            onChange={handleChange}
            required
            style={selectStyle}
          >
            <option value={""}>Select reason</option>
            {portal?.data?.settings?.reasonsList.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-sm-3">
          <select
            id="action"
            name="action"
            className="w-100"
            value={action}
            onChange={handleChange}
            required
            style={selectStyle}
          >
            <option value={""}>Select action</option>
            {/* {portal?.data?.settings?.actionsList.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))} */}
            {actionsList.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-sm-1 d-flex justify-content-end align-items-center mt-2 mt-sm-0">
          {props.item === "Return 1" ? (
            <div
              className="d-none d-sm-flex"
              role="button"
              onClick={() => props.addReturn(props.item)}
              aria-label="Add return row"
            >
              <CirclePlus className="w-5 h-5" />
            </div>
          ) : (
            <div
              className="ms-auto"
              role="button"
              onClick={() => props.deleteReturn(props.item)}
              aria-label="Delete return row"
            >
              <Trash2 className="w-5 h-5" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
